import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Humanise a carrier status code ("out_for_delivery" -> "Out for delivery"). */
function label(code) {
    const s = code.replace(/_/g, " ").trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : "Update";
}
/** Dumb tracking timeline, oldest first as received. No address or PII is ever passed in. */
export function TrackingTimeline({ events, className }) {
    if (events.length === 0) {
        return (_jsx("p", { className: "lumora-orders-muted", "data-lumora-tracking-empty": true, children: "No tracking updates yet." }));
    }
    return (_jsx("ol", { className: ["lumora-ship-timeline", className].filter(Boolean).join(" "), "data-lumora-tracking-timeline": true, children: events.map((e, i) => (_jsxs("li", { "data-lumora-tracking-event": e.code, children: [_jsx("span", { className: "lumora-ship-timeline-code", children: label(e.code) }), _jsx("time", { dateTime: e.at, className: "lumora-orders-muted", children: e.at })] }, `${e.code}-${e.at}-${i}`))) }));
}
//# sourceMappingURL=TrackingTimeline.js.map